/**
 * Sets up the listener for the mouse not in viewport feature
 */
import { useEffect } from "react";
import { SET_RENDER, ONE_PANEL_SURVEY_CONTENT } from "../../constants";
import { conditionsEngine } from "../../util";

const useOnePanelSurveyMouseNotInViewPort = (props) => {
  useEffect(() => {
    if (!props.definition) return;

    const {
      definition,
      hasClicked,
      hasHovered,
      hasMouseLeftViewport,
      hasTimedOut,
      dispatch,
      handleOnClickCondition,
      handleOnHoverCondition,
    } = props;

    const engineOptions = {
      clickCallback: handleOnClickCondition,
      hoverCallback: handleOnHoverCondition,
    };

    const {
      onePanelSurveyDisplayConditions: {
        // eslint-disable-next-line no-unused-vars
        autoPopUp,
        // eslint-disable-next-line no-unused-vars
        idleTimeOut,
        ...restOnePanelSurveyDisplayConditions
      },
    } = definition[ONE_PANEL_SURVEY_CONTENT];

    //quickly check for the mouse viewport options and set up the listener
    if (
      JSON.stringify(restOnePanelSurveyDisplayConditions).includes(
        "mouse not in viewport"
      )
    ) {
      const mouseLeaveCallback = (e) => {
        //that last condition exists because firefox/IE think a select element is outside the viewport
        if (
          e.clientY <= 0 ||
          e.clientX <= 0 ||
          e.clientX >= window.innerWidth ||
          e.clientY >= window.innerHeight
        ) {
          const isRender = conditionsEngine(
            restOnePanelSurveyDisplayConditions,
            {
              ...engineOptions,
              isHoveredTrue: hasHovered.current,
              isClickTrue: hasClicked.current,
              isMouseLeftViewportTrue: true,
              isIdled: hasTimedOut.current,
            }
          );

          if (isRender) {
            //clean up
            hasMouseLeftViewport.current = true;
            document.removeEventListener("mouseout", mouseLeaveCallback);
          }

          dispatch({
            type: SET_RENDER,
            payload: isRender,
          });
        }
      };
      document.addEventListener("mouseout", mouseLeaveCallback);
    }
  }, []);
};

export default useOnePanelSurveyMouseNotInViewPort;
